module.exports = __webpack_public_path__ + "static/img/ddzx.ea218967.png";